<template>
	<div class="u-scan flex">
		<div class="flex-grow">
			<slot></slot>
		</div>
		<div v-if="(testData || scanAuth) && !disabled" class="u-scan-button flex-center" @click="scanHandle">
			<i class="tf-scan"></i>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'

	export default {
		name: 'scanCode',

		props: {
			parse: {
				type: Boolean,
				default: true
			},
			disabled: Boolean,
			testData: [String, Object]
		},

		computed: {
			...mapGetters(['scanAuth']),
		},
		
		methods: {
			scanHandle() {
				if (this.disabled) return;
				if (this.testData) {
					this.$emit('success', this.testData);
					return;
				}
				this.scanCode({
					parse: this.parse,
					success: data => {
						this.$emit('success', data);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.u-scan {
		&-button {
			align-self: stretch;
			width: .8rem;
			border: .02rem solid var(--unit-border);
			border-left: none;
			font-size: .4rem;
			color: var(--color-main);
			background: #FAFAFA;
		}
	}
</style>
